import * as React from "react";

function SvgAdjust(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 21.2"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M1 10.6a10.5 10.5 0 1 0 21 0a10.5 10.5 0 1 0 -21 0zM19.2 14.8c.5.9-.5 2.2-1.6 1.5 0 0-4.5-2.9-7.7-4.2l-2 3.7c-.1.4-.9.9-1.6.5C.7 13.1 1.7 6.9 8.6 9l2.8-5.4c.6-.9 1.8-.7 2.1 0l5.7 11.2zM7.6 11.3C3.1 10 5.5 13 6.4 13.6l1.2-2.3zm7.6.8l-2.8-5.3-1.6 3.2c1.1.3 3.4 1.6 4.4 2.1z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdjust);
